import { render, staticRenderFns } from "./SectionQuiz.vue?vue&type=template&id=64aa5269&scoped=true&"
import script from "./SectionQuiz.vue?vue&type=script&lang=js&"
export * from "./SectionQuiz.vue?vue&type=script&lang=js&"
import style0 from "./SectionQuiz.vue?vue&type=style&index=0&id=64aa5269&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64aa5269",
  null
  
)

export default component.exports